// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-deinition-screen {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0px 20px 20px 20px;
}
.role-deinition-screen .role-definition-search-input {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 300px;
  justify-content: space-between;
  margin-left: auto;
}
.role-deinition-screen .role-definition-search-input .input-wrapper {
  width: unset !important;
}
.role-deinition-screen .role-definition-search-input .search-bar {
  margin-left: auto;
  display: flex;
  width: 300px;
  margin-right: 2%;
}
.role-deinition-screen .role-definition-search-input .btn-new-role {
  font-family: "ABBVoice-regular";
  font-size: small;
  border-radius: 18px;
  border: none;
  width: 300px;
  height: 30px;
  padding: 5px 0px rgb(255, 255, 255);
  border: 2px solid rgb(65, 104, 255);
}
.role-deinition-screen .role-definition-search-input .new-role-text {
  font-size: 14px;
  text-align: center;
}
.role-deinition-screen .role-definition-search-input .new-role-plus-icon {
  font-size: 16px;
  text-align: center;
}
.role-deinition-screen .role-definition-input-group-button {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 200px;
  justify-content: space-between;
  margin-left: auto;
  margin-top: 20px;
}
.role-deinition-screen .role-definition-input-group-button .btn-save {
  font-family: "ABBVoice-regular";
  font-size: small;
  border-radius: 18px;
  border: none;
  width: 92px;
  height: 31px;
  padding: 6px 0px;
  color: rgb(255, 255, 255);
  background: rgb(65, 104, 255);
}
.role-deinition-screen .role-definition-input-group-button .btn-cancel {
  font-family: "ABBVoice-regular";
  font-size: small;
  border-radius: 18px;
  border: none;
  width: 92px;
  height: 31px;
  padding: 5px 0px rgb(255, 255, 255);
  border: 2px solid rgb(65, 104, 255);
}
.role-deinition-screen .role-definition-table {
  background-color: var(--table-background-color);
  border-radius: 10px;
  flex-grow: 1;
}
.role-deinition-screen .role-definition-table .roles-heading {
  font-size: 14px;
  font-weight: 500;
  background-color: var(--title-container-background);
  margin: 2px;
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.role-deinition-screen .role-definition-table .table-width {
  height: auto !important;
  padding: 8px;
}
.role-deinition-screen .role-definition-table .table-width .ag-header {
  background-color: var(--table-background-color) !important;
}
.role-deinition-screen .role-definition-table input[type=text] {
  padding-block: 0;
  padding-inline: 0 !important;
}
.role-deinition-screen form {
  flex-grow: 1;
}
.role-deinition-screen .parent-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.role-deinition-screen .loader {
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #36f;
  width: 60px;
  height: 60px; /* Safari */
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.role-deinition-screen .tabulator .tabulator-row .tabulator-cell {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 8px;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 1px solid #ddd;
  border-bottom: black;
}
.role-deinition-screen .tabulator .tabulator-header .tabulator-col {
  border-right: 1px solid #ddd;
}
.role-deinition-screen .toggle-switch {
  display: flex;
  margin-bottom: 20px;
}
.role-deinition-screen .toggle-switch .ant-switch {
  overflow: hidden;
}
.role-deinition-screen .toggle-switch .ant-switch-inner-checked {
  position: absolute;
  right: 4px;
  z-index: 2;
  top: 3px;
}
.role-deinition-screen .toggle-switch .ant-switch-inner-unchecked {
  position: absolute;
  left: 2px;
  top: 25px;
}
.role-deinition-screen .user-request-table .ag-header {
  background-color: var(--table-header-color) !important;
}
.role-deinition-screen .user-request-table .MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {
  background-color: unset !important;
  padding: 0 !important;
}

.role-definition-heading {
  position: relative !important;
  font-size: 22px !important;
  margin-top: 12px !important;
  text-transform: capitalize !important;
}

.table-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.not-allowed {
  cursor: not-allowed !important;
  color: #ddd;
}

.table-width {
  height: 100%;
  width: 100% !important;
}

.grid-conatiner {
  height: 100%;
}
.grid-conatiner .col-10 {
  height: 100%;
}

.MuiInputBase-root.MuiOutlinedInput-root {
  background-color: var(--search-background-color) !important;
  padding-right: 8px;
  padding-left: 8px;
  color: var(--text-primary-color);
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana !important;
}

.css-1rlhouc .MuiInputBase-root {
  height: 31px;
  min-width: 200px;
  padding: 0px 6px 0px 12px;
  border: 1px solid var(--search-boarder-color) !important;
}

.ag-theme-quartz-dark {
  --ag-background-color:
  color-mix(in srgb, #fff, var(--table-background-color) 97%)!important;
  --ag-foreground-color: #fff;
  --ag-border-color: rgba(255, 255, 255, .16);
  --ag-secondary-border-color:
  color-mix(in srgb, transparent, var(--ag-foreground-color) 10%);
  --ag-header-background-color:
  color-mix(in srgb, #fff, #182230 93%);
  --ag-tooltip-background-color:
  color-mix(in srgb, #fff, #182230 96%);
  --ag-control-panel-background-color:
  color-mix(in srgb, #fff, #182230 93%);
  --ag-input-disabled-background-color: #68686e12;
  --ag-card-shadow: 0 1px 20px 1px black;
  --ag-input-border-color: var(--ag-border-color);
  --ag-input-disabled-border-color: rgba(255, 255, 255, .07);
  --ag-checkbox-unchecked-color: color-mix(in srgb, var(--ag-background-color), var(--ag-foreground-color) 40%);
  --ag-row-hover-color:
  color-mix(in srgb, transparent, var(--ag-active-color) 20%);
  --ag-selected-row-background-color: var(--ag-row-hover-color);
  --ag-panel-background-color: color-mix(in srgb, var(--ag-background-color), var(--ag-foreground-color) 10%);
  --ag-panel-border-color:
  color-mix(in srgb, transparent, var(--ag-foreground-color) 10%);
  --ag-menu-background-color: color-mix(in srgb, var(--ag-background-color), var(--ag-foreground-color) 10%);
  --ag-menu-border-color:
  color-mix(in srgb, transparent, var(--ag-foreground-color) 10%);
  --ag-advanced-filter-join-pill-color: #7a3a37;
  --ag-advanced-filter-column-pill-color: #355f2d;
  --ag-advanced-filter-option-pill-color: #5a3168;
  --ag-advanced-filter-value-pill-color: #374c86;
  --ag-popup-shadow: 0 0px 20px rgba(0, 0, 0, .3);
  --ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, .4);
  color-scheme: dark;
}

.MuiTableCell-root.MuiTablePagination-root {
  border-bottom: none;
  color: var(--text-primary-color) !important;
  font-family: "ABBVoice", Verdana;
  width: 100%;
  overflow: hidden;
  display: flex;
}

.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {
  min-height: 56px;
  padding-left: 32px;
  padding-right: 32px;
  background-color: var(--pagination-background-color) !important;
  display: flex;
  flex-direction: row;
  font-family: "ABBVoice", Verdana;
  justify-content: space-between;
  align-items: center;
}

.css-190euyl:last-child {
  padding: 0px;
  background-color: var(--pagination-background-color) !important;
}

.ag-ltr .ag-cell {
  border-right-width: 1px;
  border-color: transparent !important;
}

.role-deinition-screen .role-definition-table .table-width .ag-header {
  background-color: var(--table-header-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/role_definition.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;AAEJ;AAAI;EACE,uBAAA;AAEN;AAAI;EACE,iBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAEN;AAAI;EACE,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,mCAAA;AAEN;AAAI;EACE,eAAA;EACA,kBAAA;AAEN;AAAI;EACE,eAAA;EACA,kBAAA;AAEN;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AAAI;EACE,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;AAEN;AAAI;EACE,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,mCAAA;AAEN;AACE;EACE,+CAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAAI;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAEN;AAAI;EACE,uBAAA;EACA,YAAA;AAEN;AAAM;EACE,0DAAA;AAER;AAEI;EACE,gBAAA;EACA,4BAAA;AAAN;AAGE;EACE,YAAA;AADJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AADJ;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA,EACA,WAAA;EACA,kCAAA;AADJ;AAWE;EACE;IACE,uBAAA;EADJ;EAGE;IACE,yBAAA;EADJ;AACF;AAGE;EACE,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;AADJ;AAGE;EACE,4BAAA;AADJ;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AAFN;AAKI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AAHN;AAOI;EACE,sDAAA;AALN;AAOI;EACE,kCAAA;EACA,qBAAA;AALN;;AAUA;EACE,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,qCAAA;AAPF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AANF;;AAQA;EACE,8BAAA;EACA,WAAA;AALF;;AAOA;EACE,YAAA;EACA,sBAAA;AAJF;;AAMA;EACE,YAAA;AAHF;AAKE;EACE,YAAA;AAHJ;;AAOA;EACE,2DAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,2CAAA;AAJF;;AAOA;EACE,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,wDAAA;AAJF;;AAOA;EACE;uEAAA;EAEA,2BAAA;EACA,2CAAA;EACA;iEAAA;EAEA;uCAAA;EAEA;uCAAA;EAEA;uCAAA;EAEA,+CAAA;EACA,sCAAA;EACA,+CAAA;EACA,0DAAA;EACA,6GAAA;EACA;6DAAA;EAEA,6DAAA;EACA,2GAAA;EACA;iEAAA;EAEA,0GAAA;EACA;iEAAA;EAEA,6CAAA;EACA,+CAAA;EACA,+CAAA;EACA,8CAAA;EACA,+CAAA;EACA,+DAAA;EACA,kBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,2CAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;AAJF;;AAOA;EACE,YAAA;EACA,+DAAA;AAJF;;AAOA;EACE,uBAAA;EACA,oCAAA;AAJF;;AAOA;EACE,sDAAA;AAJF","sourcesContent":[".role-deinition-screen {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding: 0px 20px 20px 20px;\n  .role-definition-search-input {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n    width: 300px;\n    justify-content: space-between;\n    margin-left: auto;\n\n    .input-wrapper {\n      width: unset !important;\n    }\n    .search-bar {\n      margin-left: auto;\n      display: flex;\n      width: 300px;\n      margin-right: 2%;\n    }\n    .btn-new-role {\n      font-family: \"ABBVoice-regular\";\n      font-size: small;\n      border-radius: 18px;\n      border: none;\n      width: 300px;\n      height: 30px;\n      padding: 5px 0px rgb(255, 255, 255);\n      border: 2px solid rgb(65, 104, 255);\n    }\n    .new-role-text {\n      font-size: 14px;\n      text-align: center;\n    }\n    .new-role-plus-icon {\n      font-size: 16px;\n      text-align: center;\n    }\n  }\n  .role-definition-input-group-button {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n    width: 200px;\n    justify-content: space-between;\n    margin-left: auto;\n    margin-top: 20px;\n    .btn-save {\n      font-family: \"ABBVoice-regular\";\n      font-size: small;\n      border-radius: 18px;\n      border: none;\n      width: 92px;\n      height: 31px;\n      padding: 6px 0px;\n      color: rgb(255, 255, 255);\n      background: rgb(65, 104, 255);\n    }\n    .btn-cancel {\n      font-family: \"ABBVoice-regular\";\n      font-size: small;\n      border-radius: 18px;\n      border: none;\n      width: 92px;\n      height: 31px;\n      padding: 5px 0px rgb(255, 255, 255);\n      border: 2px solid rgb(65, 104, 255);\n    }\n  }\n  .role-definition-table {\n    background-color: var(--table-background-color);\n    border-radius: 10px;\n    flex-grow: 1;\n    .roles-heading {\n      font-size: 14px;\n      font-weight: 500;\n      background-color: var(--title-container-background);\n      margin: 2px;\n      padding: 4px 10px;\n      border-top-right-radius: 8px;\n      border-top-left-radius: 8px;\n    }\n    .table-width {\n      height: auto !important;\n      padding: 8px;\n\n      .ag-header {\n        background-color: var(--table-background-color) !important;\n      }\n      \n    }\n    input[type=\"text\"] {\n      padding-block: 0;\n      padding-inline: 0 !important;\n    }\n  }\n  form {\n    flex-grow: 1;\n  }\n  .parent-loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n  }\n  .loader {\n    border: 6px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 6px solid #36f;\n    width: 60px;\n    height: 60px;\n    -webkit-animation: spin 2s linear infinite; /* Safari */\n    animation: spin 2s linear infinite;\n  }\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .tabulator .tabulator-row .tabulator-cell {\n    display: inline-block;\n    position: relative;\n    box-sizing: border-box;\n    padding: 8px;\n    vertical-align: middle;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    border-right: 1px solid #ddd;\n    border-bottom: black;\n  }\n  .tabulator .tabulator-header .tabulator-col {\n    border-right: 1px solid #ddd;\n  }\n  .toggle-switch {\n    display: flex;\n    margin-bottom: 20px;\n\n    .ant-switch {\n      overflow: hidden;\n    }\n\n    .ant-switch-inner-checked {\n      position: absolute;\n      right: 4px;\n      z-index: 2;\n      top: 3px;\n    }\n\n    .ant-switch-inner-unchecked {\n      position: absolute;\n      left: 2px;\n      top: 25px;\n    }\n  }\n  .user-request-table {\n    .ag-header {\n      background-color: var(--table-header-color) !important;\n    }\n    .MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {\n      background-color: unset !important;\n      padding: 0 !important;\n    }\n  }\n}\n\n.role-definition-heading {\n  position: relative !important;\n  font-size: 22px !important;\n  margin-top: 12px !important;\n  text-transform: capitalize !important;\n}\n.table-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.not-allowed {\n  cursor: not-allowed !important;\n  color: #ddd;\n}\n.table-width {\n  height: 100%;\n  width: 100% !important;\n}\n.grid-conatiner {\n  height: 100%;\n\n  .col-10 {\n    height: 100%;\n  }\n}\n\n.MuiInputBase-root.MuiOutlinedInput-root {\n  background-color: var(--search-background-color) !important;\n  padding-right: 8px;\n  padding-left: 8px;\n  color: var(--text-primary-color);\n  font-size: 0.875rem;\n  font-family: \"ABBVoice\", Verdana !important;\n}\n\n.css-1rlhouc .MuiInputBase-root {\n  height: 31px;\n  min-width: 200px;\n  padding: 0px 6px 0px 12px;\n  border: 1px solid var(--search-boarder-color) !important;\n}\n\n.ag-theme-quartz-dark {\n  --ag-background-color: \ncolor-mix(in srgb, #fff, var(--table-background-color) 97%)!important;\n  --ag-foreground-color: #fff;\n  --ag-border-color: rgba(255, 255, 255, .16);\n  --ag-secondary-border-color: \ncolor-mix(in srgb, transparent, var(--ag-foreground-color) 10%);\n  --ag-header-background-color: \ncolor-mix(in srgb, #fff, #182230 93%);\n  --ag-tooltip-background-color: \ncolor-mix(in srgb, #fff, #182230 96%);\n  --ag-control-panel-background-color: \ncolor-mix(in srgb, #fff, #182230 93%);\n  --ag-input-disabled-background-color: #68686e12;\n  --ag-card-shadow: 0 1px 20px 1px black;\n  --ag-input-border-color: var(--ag-border-color);\n  --ag-input-disabled-border-color: rgba(255, 255, 255, .07);\n  --ag-checkbox-unchecked-color: color-mix(in srgb, var(--ag-background-color), var(--ag-foreground-color) 40%);\n  --ag-row-hover-color: \ncolor-mix(in srgb, transparent, var(--ag-active-color) 20%);\n  --ag-selected-row-background-color: var(--ag-row-hover-color);\n  --ag-panel-background-color: color-mix(in srgb, var(--ag-background-color), var(--ag-foreground-color) 10%);\n  --ag-panel-border-color: \ncolor-mix(in srgb, transparent, var(--ag-foreground-color) 10%);\n  --ag-menu-background-color: color-mix(in srgb, var(--ag-background-color), var(--ag-foreground-color) 10%);\n  --ag-menu-border-color: \ncolor-mix(in srgb, transparent, var(--ag-foreground-color) 10%);\n  --ag-advanced-filter-join-pill-color: #7a3a37;\n  --ag-advanced-filter-column-pill-color: #355f2d;\n  --ag-advanced-filter-option-pill-color: #5a3168;\n  --ag-advanced-filter-value-pill-color: #374c86;\n  --ag-popup-shadow: 0 0px 20px rgba(0, 0, 0, .3);\n  --ag-row-loading-skeleton-effect-color: rgba(202, 203, 204, .4);\n  color-scheme: dark;\n}\n\n.MuiTableCell-root.MuiTablePagination-root {\n  border-bottom: none;\n  color: var(--text-primary-color)!important;\n  font-family: \"ABBVoice\", Verdana;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n}\n\n.MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {\n  min-height: 56px;\n  padding-left: 32px;\n  padding-right: 32px;\n  background-color: var(--pagination-background-color)!important;\n  display: flex;\n  flex-direction: row;\n  font-family: \"ABBVoice\", Verdana;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.css-190euyl:last-child {\n  padding: 0px;\n  background-color: var(--pagination-background-color)!important;\n}\n\n.ag-ltr .ag-cell {\n  border-right-width: 1px;\n  border-color: transparent !important;\n}\n\n.role-deinition-screen .role-definition-table .table-width .ag-header {\n  background-color: var(--table-header-color) !important;;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
